var map = {
	"./aaaaaaaaa-chem.jpeg": 85490,
	"./aaaaaaaaa-chemical.png": 41066,
	"./aaaaaaaaa-cit.jpeg": 61213,
	"./aaaaaaaaaa-chemical.png": 25277,
	"./chemical.png": 36108,
	"./chemical2.png": 17796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55163;